import { render, staticRenderFns } from "./SignUpTwo.vue?vue&type=template&id=48f861db&scoped=true&"
import script from "./SignUpTwo.vue?vue&type=script&lang=js&"
export * from "./SignUpTwo.vue?vue&type=script&lang=js&"
import style0 from "./SignUpTwo.vue?vue&type=style&index=0&id=48f861db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f861db",
  null
  
)

export default component.exports